import Transform from "@ember-data/serializer/transform";
import { MedicationRequestPayload } from "core/models/prescriptions/medication-request";
import MedicationRequest from "core/models/prescriptions/medication-request";
export default class MedicationRequestsTransform extends Transform {
  deserialize(serialized) {
    return serialized.map(medicationRequest => MedicationRequest.fromPayload(medicationRequest));
  }
  serialize(deserialized) {
    return deserialized.map(medicationRequest => medicationRequest.jsonPayload);
  }
}